import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { ChatOrder } from './types'
import OrderCard from './OrderCard'
import { IconChevron } from './icons'

interface Props {
  orders: ChatOrder[]
  disabled?: boolean
}

/** Sipariş kartlarının listesi. 3'ten fazla sipariş varsa alta "Tüm Siparişlerim" linki eklenir. */
export default function OrderList({ orders, disabled }: Props) {
  if (orders.length === 0) return null

  return (
    <div className={classes.orderList}>
      {orders.map(order => (
        <OrderCard key={order.orderNumber} order={order} disabled={disabled} />
      ))}

      {orders.length > 3 && (
        <Link className={classes.viewAllOrdersLink} to='/myspecial/myorders' target='_blank' rel='noopener noreferrer'>
          Tüm Siparişlerim
          <span className={classes.viewAllOrdersChevron}>
            <IconChevron />
          </span>
        </Link>
      )}
    </div>
  )
}
